/**
 * Conditionally appends the `INVOICE_QUEUE_CONSUMER_TARGET` query param to a URL.
 *
 * This is mainly used for upload endpoints so backend components can route work
 * to a specific consumer (e.g. `local`) during development.
 */
export function withInvoiceQueueConsumerTarget(url: string): string {
  // In Next.js, only NEXT_PUBLIC_* env vars are available in the browser bundle.
  // We support both names to be resilient across environments/build setups.
  const target =
    process.env.NEXT_PUBLIC_INVOICE_QUEUE_CONSUMER_TARGET ??
    process.env.INVOICE_QUEUE_CONSUMER_TARGET;

  if (!target) return url;

  // Upload URLs in this codebase are typically absolute (api_url + path).
  // If a relative URL ever slips through, fall back to a dummy base and then
  // return the original relative part.
  try {
    const parsed = new URL(url);
    parsed.searchParams.set("INVOICE_QUEUE_CONSUMER_TARGET", String(target));
    return parsed.toString();
  } catch {
    const base = "http://localhost";
    const parsed = new URL(url, base);
    parsed.searchParams.set("INVOICE_QUEUE_CONSUMER_TARGET", String(target));
    return parsed.toString().replace(base, "");
  }
}


